import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Styles from './FormTitle.styles';

const FormTitle = ({ children }) => (
  <h3 className={classNames(Styles.title, 'text-green-600')}>{children}</h3>
);

FormTitle.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormTitle;
